import captureSentryException from '@/features/app/functions/captureSentryException';
import { IpcRequestMessage } from '@/features/mobile-app-bridge/constants/ipc-request-message-schema';
import { IpcResponseMessage } from '@/features/mobile-app-bridge/constants/ipc-response-message-schema';
import parseReactNativeIPCMessage from '@/features/mobile-app-bridge/functions/parseReactNativeIPCMessage';
import { v4 as uuid } from 'uuid';

export default function sendIpcMessage(
  message: IpcRequestMessage,
  timeout?: number
): Promise<IpcResponseMessage> {
  return new Promise((resolve, reject) => {
    if (!window.ReactNativeWebView) throw new Error('ReactNativeWebView is not available');

    const id = uuid();
    let timeoutId: NodeJS.Timeout | undefined;

    function handleResponseMessage(event: MessageEvent) {
      try {
        const response = parseReactNativeIPCMessage(event);
        if (!response || response.uuid !== id) return;
        window.removeEventListener('message', handleResponseMessage);

        if (response.type === 'WEBVIEW_IPC_SUCCESS') {
          timeoutId && clearTimeout(timeoutId);
          resolve(response.result);
        } else {
          timeoutId && clearTimeout(timeoutId);
          reject(new Error(JSON.stringify(response)));
        }
      } catch (e) {
        timeoutId && clearTimeout(timeoutId);
        captureSentryException(e, {
          extras: {
            event,
          },
        });
        console.error('Error handling IPC response message', event, e);
        reject(e);
      }
    }

    if (typeof timeout === 'number') {
      timeoutId = setTimeout(() => {
        window.removeEventListener('message', handleResponseMessage);
        reject(new Error('IPC message timeout'));
      }, timeout);
    }

    window.addEventListener('message', handleResponseMessage);
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        uuid: id,
        from: 'TIRECLOUD_RN_WEBVIEW',
        ...message,
      })
    );
  });
}
